module.exports = '0.7.0';



// WEBPACK FOOTER //
// ./src/version.js